export enum TipoOfertaEnum {
    PRODUTO_COM_DESCONTO      = 1,
    COMPRE_A_GANHE_B          = 2,
    COMPRE_A_GANHE_DESCONTO_B = 3,
    COMBO_DE_PRODUTOS         = 4,
    LEVE_E_PAGUE              = 5,
    CATEGORIA_DE_PRODUTOS     = 6,
    OFERTA_ATACAREJO          = 7
}